// extracted by mini-css-extract-plugin
export default {"sp":"sp","sp_in_preview":"sp_in_preview","sp_va_start":"sp_va_start","sp_va_end":"sp_va_end","sp_va_center":"sp_va_center"};